import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "../api/api";
import { logClientError } from "../api/errorLogger";

export default function Settings() {
  const [totalCapacity, setTotalCapacity] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const loadCapacity = useCallback(async () => {
    setError("");
    setIsLoading(true);

    try {
      const data = await apiFetch("/settings/mailbox-capacity");
      setTotalCapacity(data.totalCapacity ?? "");
    } catch (err) {
      setError(err.message);
      logClientError(err, { page: "Settings", action: "loadMailboxCapacity" });
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCapacity();
  }, [loadCapacity]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsSaving(true);

    try {
      const data = await apiFetch("/settings/mailbox-capacity", {
        method: "PATCH",
        body: JSON.stringify({
          totalCapacity: Number(totalCapacity),
          password,
        }),
      });

      setTotalCapacity(data.totalCapacity);
      setPassword("");
      setSuccess("Mailbox capacity updated.");
    } catch (err) {
      setError(err.message);
      logClientError(err, { page: "Settings", action: "updateMailboxCapacity" });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <p className="admin-page-eyebrow">Configuration</p>
          <h2>Settings</h2>
        </div>
      </div>

      {error && <p className="admin-empty-state admin-error-state">{error}</p>}
      {success && <p className="admin-empty-state admin-success-state">{success}</p>}

      {isLoading ? (
        <p className="admin-empty-state">Loading settings...</p>
      ) : (
        <div className="admin-form-panel">
          <form className="admin-form" onSubmit={handleSubmit}>
            <label>
              Total Mailbox Capacity
              <input
                type="number"
                min="0"
                step="1"
                value={totalCapacity}
                onChange={(e) => setTotalCapacity(e.target.value)}
                required
              />
            </label>

            <label>
              Confirm Password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>

            <div className="admin-form-actions">
              <button
                className="admin-button admin-button-primary"
                type="submit"
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save Capacity"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
